import utils from './utils'

const waste = (project) => {
  return [
    [{
      id: 'meta.volume',
      title: 'Volume',
      default: 0,
      inputProps: {
        type: 'number',
      },
      helperText: 'What is the volume of the item?',
      validate: {
        type: 'number',
        methods: [
          ['required', 'Required'],
          ['moreThan', 0, 'Must be more than zero'],
        ],
      },
    },{
      id: 'meta.volume_unit',
      title: 'Volume Unit',
      default: '',
      component: 'unitselect',
      unitType: 'volume',
      helperText: 'What unit is the item measured in?',
      validate: {
        type: 'string',
        methods: [
          ['required', 'Required'],
        ],
      },
    }],
    utils.unitField({
      prepend: 'meta.',
      customUnits: project.meta.units || [],
    }),
    utils.rateTable({
      inheritUnit: true,
    }), 
  ]
}

export default waste